import type React from "react";
import type { ReactNode } from "react";
import { Datepicker } from "~/components/common/parts/datepicker/Datepicker";
import { FormGroup } from "~/components/common/parts/form/FormGroup";
import { FormLabel } from "~/components/common/parts/form/FormLabel";
import type {
	ConstructionScheduleType,
	DealConstructionScheduleEdit
} from "~/models/DealConstructionSchedule";
import {
	CONSTRUCTION_NUMBERS,
	CONSTRUCTION_SCHEDULE_LABELS,
	isInvalidSchedule
} from "~/models/DealConstructionSchedule";
import { formatDate, toDate } from "~/utils/DateUtil";
import Styles from "./ScheduleInputForm.module.scss";

type Props = {
	handleChange: (newSchedules: DealConstructionScheduleEdit[]) => void;
	schedules: DealConstructionScheduleEdit[];
	touchSubmit: boolean;
};

export const ScheduleInputForm: React.FC<Props> = ({
	schedules,
	handleChange,
	touchSubmit
}: Props) => {
	const renderFormGroup = (typeNumber: ConstructionScheduleType): ReactNode => {
		const schedule =
			schedules.find(
				(s: DealConstructionScheduleEdit) =>
					s.constructionScheduleType === typeNumber
			) ?? null;
		const onChange = (dates: [Date, Date]): void => {
			const [startDate, endDate] = dates;
			const newSchedules = [...schedules];
			const index = newSchedules.findIndex(
				(s) => s.constructionScheduleType === typeNumber
			);
			const newSchedule = {
				...schedule,
				constructionScheduleType: typeNumber,
				endDate: formatDate(endDate),
				startDate: formatDate(startDate)
			};
			newSchedules.splice(index, 1, newSchedule);
			handleChange(newSchedules);
		};
		if (schedule === null) {
			return null;
		}
		return (
			<FormGroup key={typeNumber}>
				<FormLabel>{CONSTRUCTION_SCHEDULE_LABELS[typeNumber]}</FormLabel>
				<Datepicker
					endDate={toDate(schedule.endDate)}
					isClearable
					onChange={onChange}
					selectsRange
					startDate={toDate(schedule.startDate)}
				/>
				{touchSubmit && isInvalidSchedule(schedule) ? (
					<div className={Styles.InvalidMessage}>
						開始日と終了日を入力してください
					</div>
				) : null}
			</FormGroup>
		);
	};
	return <div>{CONSTRUCTION_NUMBERS.map(renderFormGroup)}</div>;
};
